import Style from "../models/Style";
import { DataTableFilterEvent, DataTablePageEvent } from 'primereact/datatable';
import StyleList from '../models/StyleList';
import StyleProductCategory from '../models/StyleProductCategory';
import StyleLazyState from '../models/StyleLazyState';
import StyleRule from '../models/StyleRule';
import SeqMap from '../models/SeqMap';
import SetupPrompt from '../models/SetupPrompt';
import ItemSpec from '../models/ItemSpec';
import StyleSetup from '../models/FullStyle';
import StyleType from '../models/StyleType';
import CodeType from '../models/CodeType';
import Chart from '../models/Chart';
import FullStyle from '../models/FullStyle';
import apiClient from "../components/apiClient";

export class StyleService {    
    static getStylesLazy(lazyState: StyleLazyState | DataTablePageEvent | DataTableFilterEvent): Promise<StyleList> {
        return apiClient.post<StyleList>(`/Style/GetStylesLazy`, lazyState).then(res => res.data);
    }

    static getStyle(styleCode: string): Promise<Style> {
        return apiClient.get<Style>(`/Style/GetStyle/${styleCode}`).then(res => res.data);
    }

    static getStyleSetup(styleCode: string): Promise<StyleSetup> {
        return apiClient.get<StyleSetup>(`/Style/GetStyleSetup/${styleCode}`).then(res => res.data);
    }

    static updateStyle(style: Style): Promise<boolean> {
        return apiClient.put<boolean>(`/Style/UpdateStyle`, style).then(res => res.data);
    }

    static getProductCategories(): Promise<StyleProductCategory[]> {
        return apiClient.get<StyleProductCategory[]>(`/Style/GetProductCategories`).then(res => res.data);
    }

    static getStyleRules(styleCode: string): Promise<StyleRule[]> {
        return apiClient.get<StyleRule[]>(`/Style/GetStyleRules/${styleCode}`).then(res => res.data);
    }

    static getSetupPrompts(styleCode: string): Promise<SetupPrompt[]> {
        return apiClient.get<SetupPrompt[]>(`/Style/GetSetupPrompts/${styleCode}`).then(res => res.data);
    }

    static getListStylesByName(q: string): Promise<Style[]> {
        return apiClient.get<Style[]>(`/Style/GetListStylesByName/${q}`).then(res => res.data);
    }

    static copyStyleFrom(styleFrom: string, styleTo: string, user: string): Promise<boolean> {
        return apiClient.put<boolean>(`/Style/CopyStyleFrom/${styleFrom}/${styleTo}/${user}`).then(res => res.data);
    }

    static updateStyleRule(styleRule: StyleRule): Promise<StyleRule> {
        return apiClient.put<StyleRule>(`/Style/UpdateStyleRule`, styleRule).then(res => res.data);
    }

    static addStyleRule(styleRule: StyleRule): Promise<StyleRule> {
        return apiClient.post<StyleRule>(`/Style/AddStyleRule`, styleRule).then(res => res.data);
    }

    static reorderRules(seqMapping: SeqMap[], styleCode: string): Promise<StyleRule[]> {
        const payload = {
            seqMapping,
            styleCode
        };
        return apiClient.post<StyleRule[]>(`/Style/ReorderRules`, payload).then(res => res.data);
    }

    static getPromptColors(styleCode: string, seq: number, regint: string): Promise<string[]> {
        return apiClient.get<string[]>(`/Style/GetPromptColors/${styleCode}/${seq}/${regint}`).then(res => res.data);
    }

    static deleteStyleRule(seq: number, styleCode: string): Promise<boolean> {
        return apiClient.delete<boolean>(`/Style/DeleteStyleRule/${seq}/${styleCode}`).then(res => res.data);
    }

    static getItemSpecsByStyleCode(styleCode: string): Promise<ItemSpec[]> {
        return apiClient.get<ItemSpec[]>(`/Style/GetItemSpecsByStyleCode/${styleCode}`).then(res => res.data);
    }

    static addItemSpecToStyleCode(itemSpec: ItemSpec): Promise<ItemSpec> {
        return apiClient.post<ItemSpec>(`/Style/AddItemSpecToStyleCode`, itemSpec).then(res => res.data);
    }

    static deleteItemSpec(id: number): Promise<boolean> {
        return apiClient.delete<boolean>(`/Style/DeleteItemSpec/${id}`).then(res => res.data);
    }

    static downloadItemSpec(itemSpec: ItemSpec) {
        apiClient.post(`/Style/downloadItemSpec`, itemSpec, { responseType: 'blob' })
            .then(response => {
                const url = window.URL.createObjectURL(response.data);
                window.open(url, '_blank');
            });
    }

    static getListStyleGarType() : Promise<CodeType[]> {
        return apiClient.get<CodeType[]>(`/Style/GetCodesByType/GAR`).then(res => res.data);
    }

    static getListTaxType() : Promise<CodeType[]> {
        return apiClient.get<CodeType[]>(`/Style/GetCodesByType/TAX`).then(res => res.data);
    }

    static getListStyleType() : Promise<StyleType[]> {
        return apiClient.get<StyleType[]>(`/Style/GetListStyleType`).then(res => res.data);
    }

    static getListPosChartType() : Promise<Chart[]> {
        return apiClient.get<Chart[]>(`/Style/GetChartsByType/POS`).then(res => res.data);
    }

    static getCharts() : Promise<Chart[]> {
        return apiClient.get<Chart[]>(`/Style/GetCharts`).then(res => res.data);
    }

    static getListArrChartType() : Promise<Chart[]> {
        return apiClient.get<Chart[]>(`/Style/GetChartsByType/ARR`).then(res => res.data);
    }

    static getListSizeChartType() : Promise<Chart[]> {
        return apiClient.get<Chart[]>(`/Style/GetChartsByType/SIZ`).then(res => res.data);
    }

    static getListIntSizeChartType() : Promise<Chart[]> {
        return apiClient.get<Chart[]>(`/Style/GetChartsByType/SIZ`).then(res => res.data);
    }

    static getListMaterialType() : Promise<CodeType[]> {
        return apiClient.get<CodeType[]>(`/Style/GetCodesByType/MAT`).then(res => res.data);
    }

    static updateStyleSetup(styleSetup: FullStyle): Promise<FullStyle> {
        console.log(styleSetup);
        return apiClient.put<FullStyle>(`/Style/UpdateStyleSetup`, styleSetup).then(res => res.data);
    }

    static addChart(chart: Chart): Promise<Chart> {
        return apiClient.post<Chart>(`/Style/AddChart`, chart).then(res => res.data);
    }

    static updateChart(chart: Chart): Promise<Chart> {
        return apiClient.put<Chart>(`/Style/UpdateChart`, chart).then(res => res.data);
    }

    static deleteChart(code: string): Promise<boolean> {
        return apiClient.delete<boolean>(`/Style/DeleteChart/${code}`).then(res => res.data);
    }
}